import { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Sboard from "./sboard";
import Uboard from "./uboard";

function Match(props) {

  // console.log('match');
  // console.log(props);

  let isOngoing = props.isOngoing;
  let isUltimate = props.isUltimate;
  let topMessage = props.topMessage;
  let lastMove = props.lastMove;
  let representations = props.representations;
  let bigRepresentations = props.bigRepresentations;
  let allAllowed = props.allAllowed;
  let nextTurn = props.nextTurn;
  let onSquareClick = props.onSquareClick;
  let backResignClick = props.backResignClick;
  let iAm = props.iAm;

  // console.log(representations.length - 1);

  const [repIndex, setRepIndex] = useState(representations.length - 1);

  useEffect(
    () => {
      // console.log(`setting repIndex to ${representations.length - 1}`);
      setRepIndex(representations.length - 1);
    }
    ,
    [representations.length],
  );

  // let testUltimateRepresentation = [
  //   [[
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ]],
  //   [[
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ]],
  //   [[
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ], [
  //     ['-', '-', 'O'],
  //     ['-', 'X', '-'],
  //     ['-', '-', '-']
  //   ]],
  // ];

  // let testBigResultRepresentation = [
  //   ['X', '-', 'O'],
  //   ['-', 'X', '-'],
  //   ['X', 'O', '-']
  // ];

  // let testSimpleRepresentation = [
  //   ['-', '-', 'O'],
  //   ['-', 'X', '-'],
  //   ['-', '-', '-']
  // ];

  let allAllowedClassName = null;
  if (allAllowed) {
    allAllowedClassName = `all-allowed-${nextTurn}`;
  }

  let theBoard;

  let navButtons = null;
  if (!isOngoing) {
    navButtons = <Row className="text-center p-1 gx-1 gy-1 mt-4">
      <Col>
        <Button onClick={() => { setRepIndex(0) }} variant="light">&lt;&lt;</Button>
      </Col>
      <Col>
        <Button onClick={() => {
          if (repIndex > 0) {
            setRepIndex(repIndex - 1);
          }
        }} variant="light">&lt;</Button>
      </Col>
      <Col>
        <Button onClick={() => {
          if (repIndex < representations.length - 1) {
            setRepIndex(repIndex + 1);
          }
        }} variant="light">&gt;</Button>
      </Col>
      <Col>
        <Button onClick={() => { setRepIndex(representations.length - 1) }} variant="light">&gt;&gt;</Button>
      </Col>
    </Row>;
  }


  if (isUltimate) {
    theBoard = <Uboard currentBigRepresentation={bigRepresentations[repIndex]} currentRepresentation={representations[repIndex]} lastMove={lastMove} onClickAction={onSquareClick} allAllowedClassName={allAllowedClassName} />;
  } else {
    theBoard = <Sboard currentRepresentation={representations[repIndex]} lastMove={lastMove} onClickAction={onSquareClick} ub={[null, null]} isAllowedClassName={null} bigResultDisplay={'-'} />;
  }

  // if (isUltimate) {
  //   theBoard = <Uboard currentBigRepresentation={bigRepresentations[representations.length - 1]} currentRepresentation={representations[representations.length - 1]} lastMove={lastMove} onClickAction={onSquareClick} allAllowedClassName={allAllowedClassName} />;
  // } else {
  //   theBoard = <Sboard currentRepresentation={representations[representations.length - 1]} lastMove={lastMove} onClickAction={onSquareClick} ub={[null, null]} isAllowedClassName={null} bigResultDisplay={'-'} />;
  // }

  return (
    <div className="Match">
      <Container fluid="md" className="d-flex flex-column justify-content-center align-items-center vh-100">

        <Row className="text-center p-1">
          <p className="h3 text-light">{topMessage}</p>
        </Row>

        {theBoard}

        {navButtons}

        <Row className="text-center p-1 mt-5">
          <Button onClick={backResignClick} variant={(isOngoing && (iAm !== 'spectating')) ? "danger" : "light"} size="lg">{(isOngoing && (iAm !== 'spectating')) ? "Resign" : "Back"}</Button>
        </Row>

      </Container>
    </div>
  );
}

export default Match;